import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReports = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 3C4 2.44772 4.44772 2 5 2H14C14.2652 2 14.5196 2.10536 14.7071 2.29289L19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3ZM6 4V20H18V9H14C13.4477 9 13 8.55228 13 8V4H6ZM15 5.41421L16.5858 7H15V5.41421Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5732 11.5163C16.8403 11.8329 16.8002 12.3061 16.4837 12.5732L13.817 14.8232C13.5376 15.0589 13.129 15.0589 12.8497 14.8232L11.1111 13.3563L8.48365 15.5732C8.16707 15.8403 7.6939 15.8002 7.42678 15.4837C7.15967 15.1671 7.19977 14.6939 7.51635 14.4268L10.6275 11.8018C10.9068 11.5661 11.3154 11.5661 11.5948 11.8018L13.3333 13.2687L15.5163 11.4268C15.8329 11.1597 16.3061 11.1998 16.5732 11.5163Z"
	})]
});
export default SvgReports;
